import *  as service from '../services/PianoTechCustomerServices';

export const FETCH_PIANOTECHCUSTOMER_LIST_STARTED = 'FETCH_PIANOTECHCUSTOMER_LIST_STARTED';
export const FETCH_PIANOTECHCUSTOMER_LIST_SUCCEEDED = 'FETCH_PIANOTECHCUSTOMER_LIST_SUCCEEDED';
export const FETCH_PIANOTECHCUSTOMER_LIST_FAILED = 'FETCH_PIANOTECHCUSTOMER_LIST_FAILED';
export const FIND_PIANOTECHCUSTOMER_STARTED = 'FIND_PIANOTECHCUSTOMER_STARTED';
export const FIND_PIANOTECHCUSTOMER_SUCCEEDED = 'FIND_PIANOTECHCUSTOMER_SUCCEEDED';
export const FIND_PIANOTECHCUSTOMER_FAILED = 'FIND_PIANOTECHCUSTOMER_FAILED';
export const SAVE_PIANOTECHCUSTOMER_STARTED = 'SAVE_PIANOTECHCUSTOMER_STARTED';
export const SAVE_PIANOTECHCUSTOMER_SUCCEEDED = 'SAVE_PIANOTECHCUSTOMER_SUCCEEDED';
export const SAVE_PIANOTECHCUSTOMER_FAILED = 'SAVE_PIANOTECHCUSTOMER_FAILED';
export const RETURN_TO_PIANOTECHCUSTOMER_LIST = 'RETURN_TO_PIANOTECHCUSTOMER_LIST';
export const SWITCH_EDIT_TYPE_PIANOTECHCUSTOMER = 'SWITCH_EDIT_TYPE_PIANOTECHCUSTOMER';
export const PIANOTECHCUSTOMER_MODIFIED = 'PIANOTECHCUSTOMER_MODIFIED';
export const PIANOTECHCUSTOMER_VALIDATE = 'PIANOTECHCUSTOMER_VALIDATE';
export const FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_STARTED = 'FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_STARTED';
export const FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_SUCCEEDED = 'FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_SUCCEEDED';
export const FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_FAILED = 'FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_FAILED';
export const PIANOTECHCUSTOMER_VIEW_PIANO = 'PIANOTECHCUSTOMER_VIEW_PIANO';
export const PIANOTECHCUSTOMER_PIANO_MAINTENANCE_TYPE = 'PIANOTECHCUSTOMER_PIANO_MAINTENANCE_TYPE';
export const PIANOTECHCUSTOMER_CONFIRM_DELETE_PIANO = 'PIANOTECHCUSTOMER_CONFIRM_DELETE_PIANO';
export const PIANOTECHCUSTOMER_SHOW_APPOINTMENT_TABLE_CHANGE = 'PIANOTECHCUSTOMER_SHOW_APPOINTMENT_TABLE_CHANGE';
export const PIANOTECHCUSTOMER_CURRENT_PIANO_CHANGE = 'PIANOTECHCUSTOMER_CURRENT_PIANO_CHANGE';
export const PIANOTECHCUSTOMER_APPOINTMENT_CHANGE = 'PIANOTECHCUSTOMER_APPOINTMENT_CHANGE';
export const PIANOTECHCUSTOMER_PIANO_ID_CHANGE = 'PIANOTECHCUSTOMER_PIANO_ID_CHANGE';
export const PIANOTECHCUSTOMER_SHOW_APPOINTMENT_CHANGE = 'PIANOTECHCUSTOMER_SHOW_APPOINTMENT_CHANGE';
export const PIANOTECHCUSTOMER_SET_DATES = 'PIANOTECHCUSTOMER_SET_DATES';
export const PIANOTECHCUSTOMER_UPDATE_TIMESLOTS = 'PIANOTECHCUSTOMER_UPDATE_TIMESLOTS';
export const PIANOTECHCUSTOMER_HIDE_UNAVAILABLE_SLOTS = 'PIANOTECHCUSTOMER_HIDE_UNAVAILABLE_SLOTS';
export const PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE = 'PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE';
export const PIANOTECHCUSTOMER_CONFIRM_DELETE_APPOINTMENT = 'PIANOTECHCUSTOMER_CONFIRM_DELETE_APPOINTMENT';
export const PIANOTECHCUSTOMER_APPOINTMENT_UPDATE_COMPLETE = 'PIANOTECHCUSTOMER_APPOINTMENT_UPDATE_COMPLETE';
export const PIANOTECHCUSTOMER_WEEK_APPOINTMENT_START_DATE_CHANGE = 'PIANOTECHCUSTOMER_WEEK_APPOINTMENT_START_DATE_CHANGE';
export const PIANOTECHCUSTOMER_ORIGINAL_APPOINTMENT_CHANGE = 'PIANOTECHCUSTOMER_ORIGINAL_APPOINTMENT_CHANGE';

function fetchPianoTechCustomerListSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechCustomerList = jsonResponse.pianoTechCustomerList;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FETCH_PIANOTECHCUSTOMER_LIST_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FETCH_PIANOTECHCUSTOMER_LIST_SUCCEEDED,
        pianoTechCustomerList
    }
}

function fetchPianoTechCustomerListFailed(response) {
    const errorMessage = 'Failed to retrieve PianoTechCustomer list.';

    return {
        type: FETCH_PIANOTECHCUSTOMER_LIST_FAILED,
        message: errorMessage
    }
}

export function fetchPianoTechCustomerList() {
    return dispatch => {

        dispatch({
            type: FETCH_PIANOTECHCUSTOMER_LIST_STARTED
        });

        service
            .getPianoTechCustomerList()
            .then(resp => {
                dispatch(fetchPianoTechCustomerListSucceeded(resp))
            })
            .catch(error => {
                dispatch(fetchPianoTechCustomerListFailed(error))
            });
    }
}

function findPianoTechCustomerSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechCustomer = jsonResponse.pianoTechCustomer;
    const originalPianoTechCustomer = Object.assign({}, pianoTechCustomer);

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FIND_PIANOTECHCUSTOMER_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FIND_PIANOTECHCUSTOMER_SUCCEEDED,
        pianoTechCustomer,
        originalPianoTechCustomer,
    }
}

function findPianoTechCustomerFailed(response) {
    const errorMessage = 'Failed to find PianoTechCustomer.';

    return {
        type: FIND_PIANOTECHCUSTOMER_FAILED,
        message: errorMessage
    }
}

export function findPianoTechCustomer(customerId) {
    return dispatch => {

        service
            .findPianoTechCustomer(customerId)
            .then(resp => {
                dispatch(findPianoTechCustomerSucceeded(resp))
            })
            .catch(error => {
                dispatch(findPianoTechCustomerFailed(error))
            });
    }
}

function savePianoTechCustomerSucceeded(response, pianoTechCustomer) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const message = 'PianoTechCustomer ' + pianoTechCustomer.maintenanceType + ' Successful.';
    let updatedPianoTechCustomer = pianoTechCustomer;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: SAVE_PIANOTECHCUSTOMER_FAILED,
            message: errorMessage,
        }
    }

    if (jsonResponse.pianoTechCustomer) {
        updatedPianoTechCustomer = jsonResponse.pianoTechCustomer;
    }

    return {
        type: SAVE_PIANOTECHCUSTOMER_SUCCEEDED,
        pianoTechCustomer: updatedPianoTechCustomer,
        message,
    }
}

function savePianoTechCustomerFailed(response) {
    const errorMessage = 'Action failed: ' + response.message;

    return {
        type: SAVE_PIANOTECHCUSTOMER_FAILED,
        message: errorMessage
    }
}

export function savePianoTechCustomer(pianoTechCustomer) {
    return dispatch => {

        service
            .savePianoTechCustomer(pianoTechCustomer)
            .then(resp => {
                dispatch(savePianoTechCustomerSucceeded(resp, pianoTechCustomer))
            })
            .catch(error => {
                dispatch(savePianoTechCustomerFailed(error))
            });
    }
}

export function fetchPianoTechCustomerListByCompany(companyId) {
    return dispatch => {
        dispatch({
            type: FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_STARTED
        });

        service
            .getPianoTechCustomerListByCompany(companyId)
            .then(resp => {
                dispatch(fetchPianoTechCustomerListByCompanySucceeded(resp))
            }
            )
            .catch(error => {
                dispatch(fetchPianoTechCustomerListByCompanyFailed(error))
            });
    }
}

function fetchPianoTechCustomerListByCompanySucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));

    return {
        type: FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_SUCCEEDED,
        pianoTechCustomerList: jsonResponse.pianoTechCustomerList,
    }
}

function fetchPianoTechCustomerListByCompanyFailed(response) {
    const errorMessage = 'Action failed: ' + response.message;

    return {
        type: FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_FAILED,
        message: errorMessage
    }
}

